import { render } from "./ProgressOrders.vue?vue&type=template&id=a98c0c0a&scoped=true"
import script from "./ProgressOrders.vue?vue&type=script&lang=js"
export * from "./ProgressOrders.vue?vue&type=script&lang=js"

import "./ProgressOrders.vue?vue&type=style&index=0&id=a98c0c0a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98c0c0a"]])

export default __exports__